import { User } from '../../../types';

export type UserInfoProps = {
  translation: { [key: string]: string };
  profile: object;
  registration: {
    enterEmail: object;
    user: Partial<
      Pick<
        User,
        | 'address_street_1'
        | 'state'
        | 'zip_code'
        | 'adult_family_members'
        | 'child_family_members'
        | 'senior_family_members'
      >
    >;
  };
  actions: { [key: string]: Function };
};
